import * as React from "react";
import { CSSTransition } from "react-transition-group";
import { Container } from "../../container/container.mjs";
import { Notice } from "../../notice/notice.mjs";
const HeaderOverlayNotice = (props) => {
  const noticeRef = React.useRef(null);
  const wrapperRef = React.useRef(null);
  const { notice, ...rest } = props;
  const { type = "info", ...noticeRest } = notice;
  const getNoticeHeight = () => {
    if (noticeRef.current) {
      return noticeRef.current.offsetHeight;
    }
  };
  const [noticeWrapperHeight, setNoticeWrapperHeight] = React.useState(getNoticeHeight());
  const overlayNoticeBEM = () => {
    const classArray = ["header__overlay-notice"];
    return classArray.join(" ");
  };
  const overLayNoticeWrapperBEM = () => {
    const classArray = ["header__overlay-notice-wrapper"];
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(
    CSSTransition,
    {
      ...rest,
      onEnter: () => setNoticeWrapperHeight(0),
      onEntering: () => setNoticeWrapperHeight(getNoticeHeight()),
      onEntered: () => setNoticeWrapperHeight(void 0),
      onExit: () => setNoticeWrapperHeight(getNoticeHeight()),
      onExiting: () => setNoticeWrapperHeight(0),
      nodeRef: wrapperRef
    },
    /* @__PURE__ */ React.createElement("div", { className: overLayNoticeWrapperBEM(), style: { height: noticeWrapperHeight }, ref: wrapperRef }, /* @__PURE__ */ React.createElement("div", { className: overlayNoticeBEM(), ref: noticeRef }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Notice, { align: "center", type, fullWidth: true, ...noticeRest }))))
  );
};
export {
  HeaderOverlayNotice
};
